import React from "react";
import { Link } from "react-router";
import { IconButton } from "@/shared/ui/IconButton";
import { Center, Column } from "@/shared/ui/Blocks";

type Variant = "default" | "candidate";

interface EmptyStateProps {
  variant: Variant;
  text: string;
  posNotConfed?: boolean;
  posId?: string;
  visible?: boolean;
}

const variantStyles: Record<Variant, string> = {
  default: "bg-[url('/src/images/competencies-map-empty.png')]",
  candidate: "bg-[url('/src/images/candidate-competencies-blank.jpg')]",
};

const EmptyState: React.FC<EmptyStateProps> = ({ variant, text, visible }) => {
  if (!visible) return null;
  return (
    <Column>
      <Center
        className={`flex w-screen md:w-[516px] h-[516px] items-center self-center flex-col
        ${variantStyles[variant]}
        bg-contain bg-no-repeat bg-position-[center_left_6px] `}
      >
        <div className="flex justify-center items-center">
          <p className="p-3 bg-black/80 rounded shadow-md text-base leading-6 font-normal text-white max-w-[320px] text-center">
            {text}
          </p>
        </div>
      </Center>
    </Column>
  );
};

export default EmptyState;
